export enum FeeAmountPercentageOf {
    TOTAL_LOAN_AMOUNT = 'TOTAL_LOAN_AMOUNT',
    BASE_LOAN_AMOUNT = 'BASE_LOAN_AMOUNT'
}

export const feeAmountPercentageOfDisplay = {
    [FeeAmountPercentageOf.TOTAL_LOAN_AMOUNT]: 'Total loan amount',
    [FeeAmountPercentageOf.BASE_LOAN_AMOUNT]: 'Base loan amount'
};
